module.exports = __webpack_public_path__ + "static/img/logo.d0cc254e.png";